import React from 'react';
import styled from '@emotion/styled/macro';
import { convertStringToArray } from '../../../utils/utils';
import { PAtom } from '../../../atoms/text-atoms/text-atoms';
import { generateKey } from '../../../utils/utils';

const FormattedText = ({ inputText, className }) => {
  if (typeof inputText === 'string') {
    const textArray = convertStringToArray(inputText);
    return (
      <div className={className}>
        {textArray.map((textElement, index) => {
          return (
            <PAtom key={generateKey(textElement, index)}>{textElement}</PAtom>
          );
        })}
      </div>
    );
  } else {
    console.warn(
      `FormattedText received non valid argument - inputText: `,
      inputText
    );
    return null;
  }
};

// === FormattedText CSS ===
const StyledFormattedText = styled(FormattedText)``;

export default StyledFormattedText;
